<!--
Author: Lsc
Date: 2019-08-20
Desc: 我的预约，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-order-sell-list bizcomp ' + className">
        <comp-title :title="title" />
        <el-table :data="sfund" style="width: 100%" class="tab-list-tit">
            <el-table-column label="基金名称" width="320" class-name="fund-offset">
                <template slot-scope="scope">
                    <span v-html="getFundName(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column label="支付方式" width="200" class-name="fund-offset" align="center">
                <template slot-scope="scope">
                    <span v-html="$cache.getDict('110080',scope.row.channelid)" />
                </template>
            </el-table-column>
            <el-table-column label="基金份额" align="center">
                <template slot-scope="scope">
                    <div v-html="$util.fmtNum(scope.row.fundvolbalance)" />
                </template>
            </el-table-column>
            <el-table-column label="可用份额" align="center">
                <template slot-scope="scope">
                    <div v-html="$util.fmtNum(scope.row.availablevol)" />
                </template>
            </el-table-column>
            <el-table-column prop="status" label="基金状态" align="center" :formatter="formatterStatus" />
            <el-table-column label="操作" align="center" :width="100">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="$util.checkOrderSell(scope.row) || (scope.row.availablevol - 0 == 0)"
                        class="item"
                        effect="info"
                        :content="($util.checkOrderSell(scope.row) || '可用份额为0') + ',不能赎回'"
                        placement="left"
                    >
                        <el-button type="lock" size="small">
                            赎回
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        type="info"
                        plain
                        size="small"
                        v-on:click.stop="sellOrder(scope.row)"
                    >
                        赎回
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "MyOrder",
    mixins: [mixin],
    data () {
        return {
            sfund: []
        };
    },
    created () {
        this.getFundLists();
    },
    methods: {
        sellOrder (data) {
            const _this = this;
            // 处理基金适当性信息
            this.$util.fundRiskCheck(this, data, res => {
                if (res) {
                    const _x = Object.assign({}, res, { way: "7", proto: "bookingsell" });
                    _this.$router.push({ name: "ordersell", query: _x });
                }
            });
        },
        formatterStatus (row, column, value) {
            return this.$cache.getDict("130011", value);
        },
        // 获取基金名称显示
        getFundName (val) {
            return val.fundname + "(" + val.fundcode + ")";
        },
        // 获取资产信息
        getFundLists () {
            const _this = this;
            this.$util.request("booking/sell/cust", { businessflag: "7" }, "GET").then(res => {
                if (res.data) {
                    _this.sfund = res.data;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-order-sell-list {
    .wisdom-icon {
        font-size: $f12;
        display: inline-block;
        font-style: normal;
        background-color: $color-c;
        color: $text-color6;
        width: 18px;
        height: 18px;
        line-height: 18px;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        margin-right: 4px;
    }
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: $border-color3;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 50px;
        padding: 0 20px;
        .el-tabs__active-bar {
            background: $color-a;
        }
        .el-tabs__item {
            font-size: $f18;
            &.is-active {
                color: $color-a;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
}
</style>
